import { createTheme, Theme } from "@mui/material";
import { forEach, merge } from "lodash";
import { themeColors } from "./themeColors";
import themeOptions from "./themeOptions";

function createDashboardThemes(): { [key: string]: Theme } {
  let themes: { [key: string]: Theme } = {};

  forEach(themeColors, (value, key) => {
    themes[key] = createTheme(merge({}, themeOptions, value));
  });

  return themes;
}

export const themes = createDashboardThemes();